import React, { Component, Fragment } from 'react';
import $ from 'jquery';

class BiodataMenu extends Component {

    componentDidMount = () => {
        // menu config 
        var minSc = window.matchMedia("(min-width: 1200px)");
        if (minSc.matches) {
            document.getElementById("chck2").checked = true;
        } else {
            document.getElementById("chck2").checked = false;
        }

        // konfig tabs menu profile-------------------------------------->
        // default tabs 
        $('#navRight .navRight-item:first').addClass('active');
        $('.tabsCon').addClass('hidden');
        $('.tabsCon:first').removeClass('hidden');
        // konfigurasi dengan klik event 
        $('#navRight .navRight-item').on("click", function () {
            // get id menu tabs 
            var aktifTab = $(this).attr('id');
            // aktif menu tabs 
            $('#navRight .navRight-item').removeClass('active');
            $(this).addClass('active');
            // konfigurasi tabs 
            $('.tabsCon').addClass('hidden');
            $('#' + aktifTab + 'box').removeClass('hidden');
        });
        // end konfig tabs menu profile ---------------------------------->
    }

    render() {
        return (
            <Fragment>
                <div className="col-xl-12 mt-4 mb-1 smoothTabs">
                    <div className="TapS" id="tabs" style={{overflowX: 'none'}}>
                        <div className="tapbs">
                            <input type="checkbox" id="chck2" className="checkBox" />
                            <label className="tapbs-label" id="tabs-label" htmlFor="chck2">Menu Biodata</label>
                            <div className="tapbs-content">
                                <ul className="navRight" id="navRight">
                                    <li className="navRight-item" id="tab1">
                                        <a className="navRight-link" style={{cursor: 'pointer'}}>
                                            <i className="ti-user menu-icon" />
                                            <span className="menu-title">Data Umum</span>
                                        </a>
                                    </li>
                                    <li className="navRight-item" id="tab2">
                                        <a className="navRight-link" style={{cursor: 'pointer'}}>
                                            <i className="ti-id-badge menu-icon" />
                                            <span className="menu-title">Orang tua/wali</span>
                                        </a>
                                    </li>
                                    <li className="navRight-item" id="tab3">
                                        <a className="navRight-link" style={{cursor: 'pointer'}}>
                                            <i className="ti-wheelchair menu-icon" />
                                            <span className="menu-title">Kebutuhan khusus</span>
                                        </a>
                                    </li>
                                    <li className="navRight-item" id="tab4">
                                        <a className="navRight-link" style={{cursor: 'pointer'}}>
                                            <i className="ti-info-alt menu-icon" />
                                            <span className="menu-title">Riwayat transfer</span>
                                        </a>
                                    </li>
                                    <li className="navRight-item" id="tab5">
                                        <a className="navRight-link" style={{cursor: 'pointer'}}>
                                            <i className="ti-upload menu-icon" />
                                            <span className="menu-title">Unggah Berkas</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <label className="footer-taps" id="tabs-label" htmlFor="chck2"></label>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default BiodataMenu;